var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorseshoe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "218.14mm",
    height: "99.629mm",
    viewBox: "0 0 218.14 99.629",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.4812 -5.1143)",
    fill: "#00c0ff",
    stroke: "#000",
    strokeWidth: 0.37118
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.333,
    y: 15.3,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.962,
    y: 15.3,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -54.929,
    y: 2.7044,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 54.929,
    y: -22.333,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 15.3,
    y: -200.48,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.22,
    y: 68.827,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.22,
    y: 15.3,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(0,-1,-1,0,0,0)",
    x: -94.558,
    y: -200.48,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(-1,1)",
    x: -180.85,
    y: 43.087,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.59,
    y: 15.3,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.333,
    y: 68.827,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.333,
    y: 43.087,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorseshoe);
export default __webpack_public_path__ + "static/media/horseshoe.9581af5827e2841b575d57e140b886df.svg";
export { ForwardRef as ReactComponent };